__turbopack_context__.v({
  "card": "AcrCyberProtection-module__Hw1aba__card",
  "cardDesc": "AcrCyberProtection-module__Hw1aba__cardDesc",
  "cardTitle": "AcrCyberProtection-module__Hw1aba__cardTitle",
  "headingBox": "AcrCyberProtection-module__Hw1aba__headingBox",
  "iconBox": "AcrCyberProtection-module__Hw1aba__iconBox",
  "subtext": "AcrCyberProtection-module__Hw1aba__subtext",
  "textCol": "AcrCyberProtection-module__Hw1aba__textCol",
  "title": "AcrCyberProtection-module__Hw1aba__title",
  "wrapper": "AcrCyberProtection-module__Hw1aba__wrapper",
});
